import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";
import store from "../store";
import { setTokenExpired } from "../Redux/authSlice";
import authService from "../_services/auth.service";
import wlTokenService from "../_services/wlToken.service";
import { Loader } from "../components/Loader";
import { getCookie } from "../lib/cookies";
import {
  getCustomerFromMemory,
  setCustomerInMemory,
  setWhitelabelInMemory,
} from "../lib/sharedSessionMemory";

const RECOVERY_TIMEOUT_MS = 2500;

const isAuthPath = () =>
  typeof window !== "undefined" && window.location.pathname.includes("/auth");

const isSessionReadySync = () =>
  isAuthPath() ||
  (typeof window !== "undefined" &&
    (!!getCustomerFromMemory() || (!getCookie("wlt") && !getCookie("wlrt"))));

export function SessionRecoveryProvider({ children }) {
  const [recoveryReady, setRecoveryReady] = useState(isSessionReadySync);
  const location = useLocation();
  const pathname = location?.pathname || (typeof window !== "undefined" ? window.location.pathname : "");
  const isAuthPage = pathname.includes("/auth");

  const isValidateChannel500 = (error) =>
    error?.response?.status === 500 &&
    String(error?.config?.url || "").includes("/jwt/validate-channel");

  useEffect(() => {
    if (isAuthPage) {
      setRecoveryReady(true);
      return;
    }

    let cancelled = false;
    const timeoutId = setTimeout(() => {
      if (!cancelled) setRecoveryReady(true);
    }, RECOVERY_TIMEOUT_MS);

    const runRecovery = async () => {
      try {
        let token = getCookie("wlt");
        const refreshToken = getCookie("wlrt");
        const customer = getCustomerFromMemory();

        if (token && customer) {
          if (!cancelled) setRecoveryReady(true);
          return;
        }

        if (!token && refreshToken) {
          token = await wlTokenService.refreshToken();
        }

        if (token && !customer) {
          const authData = await authService.postValidateChannelDeduped();

          if (authData?.success && !cancelled) {
            wlTokenService.saveTokens(authData, { accessToken: token });
            authService.saveOAuthFromValidateChannelResponse(authData);
            setCustomerInMemory(authData);
            const whitelabelData =
              authData?.whitelabel ||
              authData?.data?.whitelabel ||
              authData?.data?.config?.whitelabel;
            if (whitelabelData) {
              setWhitelabelInMemory(whitelabelData);
            }
            store.dispatch(setTokenExpired(false));
          } else if (!authData?.success && !cancelled) {
            store.dispatch(setTokenExpired(true));
          }
        }
      } catch (err) {
        console.warn("Recuperação de sessão (ITP):", err?.message || err);
        if (isValidateChannel500(err)) {
          wlTokenService.clearTokens();
          store.dispatch(setTokenExpired(true));
        }
      } finally {
        if (!cancelled) setRecoveryReady(true);
      }
    };

    runRecovery();
    return () => {
      cancelled = true;
      clearTimeout(timeoutId);
    };
  }, [isAuthPage]);

  if (!recoveryReady) {
    return <Loader />;
  }

  return <>{children}</>;
}

SessionRecoveryProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
